export default __webpack_public_path__ + "static/media/ease-with-recovery.0b9d3b50.png";